<template>
  <div class="tour-guide">
    <div class="tour-guide__top">
      <div class="tour-guide__top-content u-flex-grow">
        <div
          href="#"
          @click.stop.prevent="openExpertLink"
          target="_blank"
          class="tour-guide__title serp-detail__section-title"
        >
          {{ $t("serpDetail.organizer.organized") }}:
          <template v-if="isExpert">{{
              $t("serpDetail.organizer.expert")
            }}</template
          ><template v-else>{{ $t("serpDetail.organizer.guide") }}</template>
          {{ name }}
        </div>
        <div v-if="isExpert" class="tour-guide__stats">
          <button-icon tag="span">
            <template #icon>
              <icon icon="star" />
            </template>
            <span class="font-regular">
              <template v-if="expertData.count_reviews">
                {{ expertData.rating_expert }}
              </template>
              <span class="u-text-secondary"
              >({{ $tc("reviews.reviews", +expertData.count_reviews) }})</span
              >
            </span>
          </button-icon>
          <button-icon tag="span">
            <template #icon>
              <icon icon="flag" />
            </template>
            <span class="font-regular">{{ expertData.travel_held }}</span>
          </button-icon>
          <button-icon v-if="expertData.trust_check" tag="span">
            <template #icon>
              <icon icon="icon-shield-checked" />
            </template>
            <span class="font-regular">
              {{ $t("common.verified") }}&nbsp;&mdash;
              {{ expertData.date_register }}
            </span>
          </button-icon>
        </div>
        <div
          v-else
          class="tour-guide__subtitle font-semibold"
          v-html="
            $t('serpDetail.organizer.fromTeam', { name: expertData.name })
          "
        ></div>
      </div>
      <div
        href="#"
        :title="name"
        target="_blank"
        class="tour-guide__top-avatar u-flex-shrink-0"
      >
        <avatar
          :name="name"
          :photo="avatar"
          @click.stop.prevent="openExpertLink"
        />
        <Button
          v-if="isExpert"
          type="button"
          tag="button"
          :color="getChatButtonClass"
          class="tour-guide__ask-button"
          squared
          @click="clickAskButton"
          :text="$t('common.contact')"
        />
      </div>
    </div>
    <extension-cropped>
      <div v-html="tourLeaderInfo"></div>
    </extension-cropped>
    <div v-if="isExpert" class="tour-guide__ask">
      <Button
        type="button"
        tag="button"
        :color="getChatButtonClass"
        class="tour-guide__ask-button"
        squared
        @click="clickAskButton"
        :text="$t('common.contact')"
      />
      <popup-contact-travel-expert
        v-model="popups.ask"
        :expert-data="expertData"
        :tour-name="tour.name"
        :trip-id="tripId"
      />
    </div>
  </div>
</template>

<script>
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import Avatar from "@/components/ui-kit/avatar/index.vue";
import ExtensionCropped from "@/components/ui-kit/extension-cropped/index.vue";
import Button from "@/components/ui-kit/button/index.vue";
import PopupContactTravelExpert from "@/components/organisms/contact-travel-expert/popup.vue";
import {ytEvents} from "@/plugins/analytics";
import {abTestController} from "@/plugins/abtest";

export default {
  components: {
    ButtonIcon,
    Icon,
    Avatar,
    ExtensionCropped,
    Button,
    PopupContactTravelExpert,
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
    isExpert: {
      type: Boolean,
      default: false,
    },
    tripId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      popups: {
        ask: false,
      },
    };
  },
  computed: {
    expertData() {
      return this.tour.expert_data;
    },
    tourLeader() {
      return this.tour.tour_leader;
    },
    tourLeaderInfo() {
      return this.tour?.tour_leader?.description ?? this.tour.tour_leader_info?.replace(/(<([^>]+)>)/gi, "");
    },
    name() {
      return this.isExpert ? this.expertData.name : this.tourLeader.name;
    },
    avatar() {
      return this.isExpert ? this.expertData.avatar : this.tourLeader.photo_src;
    },
    link() {
      return this.expertData.link;
    },
    getChatButtonClass() {
      return this.isAbTest15919() ? 'violet-1' : 'gray';
    },
  },
  methods: {
    openExpertLink(event) {
      event.preventDefault(); // Предотвращаем стандартное поведение клика
      event.stopPropagation(); // Останавливаем всплытие события
      fakeWindow.open(this.link,'_blank').focus();
    },
    trackEvents(cat, name, lbl) {
      ytEvents.track(cat, name, lbl);
    },
    isAbTest15919() {
      return abTestController.getSegment(15919) === 'B'
    },
    clickAskButton() {
      this.popups.ask = true;
      this.trackEvents('Tour detail', 'Click Message to expert button', );
      if (typeof window.youtravel.DataCollector !== "undefined") {
        window.youtravel.DataCollector.trackEvent("Tour detail", "Click Message to expert button", {
          'tour_id': this.tripId || "",
          'list': "",
          'filter': {},
          'additional': {},
          'meta': {}
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-guide {
  &:not(:last-child) {
    margin-bottom: 40px;
  }

  &__top {
    display: flex;
    align-items: flex-start;
    margin-bottom: 32px;

    &-content {
      @include mixin.size-md-min {
        padding-top: 10px;
      }
    }

    &-avatar {
      display: block;
      cursor: pointer;
      width: 64px;
      margin-left: 20px;

      & .tour-guide__ask-button {
        display: none;
      }

      @include mixin.size-md-min {
        display: flex;
        width: 116px;
        flex-direction: column;
        align-items: center;

        & .avatar {
          width: 88px;
        }

        & .tour-guide__ask-button {
          margin: 12px 0 0 0;
          display: block;
        }
      }
    }
  }

  &__title {
    display: block;
    cursor: pointer;
    color: var.$black;
    margin: 0;
  }

  &__subtitle {
    margin-top: 12px;
  }

  &__stats {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > * {
      margin-top: 9px;

      &:not(:last-child) {
        margin-right: 16px;
      }
    }
  }

  &__ask {
    margin-top: 32px;

    @include mixin.size-md-min {
      display: none;
    }

    &-button {
      width: 100%;

      @include mixin.size-sm-min {
        width: auto;
      }
    }
  }
}
</style>
